const UploadOrderIcon = ({ className = '' }) => {
  return (
    <svg
      width="65"
      height="64"
      viewBox="0 0 65 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Document base */}
      <path
        d="M45 10H20C17.7909 10 16 11.7909 16 14V50C16 52.2091 17.7909 54 20 54H45C47.2091 54 49 52.2091 49 50V14C49 11.7909 47.2091 10 45 10Z"
        fill="#F2B058"
      />
      {/* Document inner */}
      <path
        d="M43 14H22C20.8954 14 20 14.8954 20 16V48C20 49.1046 20.8954 50 22 50H43C44.1046 50 45 49.1046 45 48V16C45 14.8954 44.1046 14 43 14Z"
        fill="white"
      />
      {/* Line 1 */}
      <path
        d="M25 22H40"
        stroke="#D97706"
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* Line 2 */}
      <path
        d="M25 28H40"
        stroke="#D97706"
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* Line 3 */}
      <path
        d="M25 34H33"
        stroke="#D97706"
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* Upload circle */}
      <circle cx="40" cy="44" r="10" fill="#D97706" />
      {/* Upload arrow */}
      <path
        d="M40 40V48M40 40L37 43M40 40L43 43"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default UploadOrderIcon
